import $ from 'jquery';
import Parsley from 'parsleyjs';

import 'parsleyjs/dist/i18n/nl';
import 'parsleyjs/dist/i18n/de';
import 'parsleyjs/dist/i18n/fr';

Parsley.options.errorClass = 'is-error';
Parsley.options.excluded = 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden, #taxationForm';
Parsley.options.successClass = 'is-success';
Parsley.options.errorsWrapper = '<ul class="parsley-errors-list" aria-live="assertive"></ul>';

Parsley.addMessages('nl', {
    mincheck: 'Selecteer tenminste %s optie(s).',
    maxcheck: 'Selecteer maximaal %s optie(s).',
    check: 'Selecteer tussen %s en %s optie(s).',
});

Parsley.addMessages('fr_lu', {
    mincheck: 'Selecteer tenminste %s optie(s).',
    maxcheck: 'Selecteer maximaal %s optie(s).',
    check: 'Selecteer tussen %s en %s optie(s).',
});

Parsley.addMessages('de_lu', {
    mincheck: 'Selecteer tenminste %s optie(s).',
    maxcheck: 'Selecteer maximaal %s optie(s).',
    check: 'Selecteer tussen %s en %s optie(s).',
});

Parsley.addMessages('nl_be', {
    mincheck: 'Selecteer tenminste %s optie(s).',
    maxcheck: 'Selecteer maximaal %s optie(s).',
    check: 'Selecteer tussen %s en %s optie(s).',
});

Parsley.addMessages('de_be', {
    mincheck: 'Selecteer tenminste %s optie(s).',
    maxcheck: 'Selecteer maximaal %s optie(s).',
    check: 'Selecteer tussen %s en %s optie(s).',
});

Parsley.addMessages('fr_be', {
    mincheck: 'Selecteer tenminste %s optie(s).',
    maxcheck: 'Selecteer maximaal %s optie(s).',
    check: 'Selecteer tussen %s en %s optie(s).',
});

function setParsleyLocale() {
    const lang = document.documentElement.lang;

    const languageMap = {
        'nl_be': 'nl',
        'de_be': 'de',
        'de_lu': 'de',
        'fr_be': 'fr',
        'fr_lu': 'fr'
    };

    if (languageMap.hasOwnProperty(lang)) {
        Parsley.setLocale(languageMap[lang]);
    } else {
        Parsley.setLocale(lang);
    }
}

setParsleyLocale();

Parsley.addValidator('maxNumberOfFiles', {
    validateString: function(_value, maxNumberOfFiles, parsleyInstance) {
        if (!window.FormData) {
            return true;
        }

        const files = parsleyInstance.$element[0].files;

        return files.length <= maxNumberOfFiles;
    },
    requirementType: 'integer',
    messages: {
        nl: 'Je mag maximaal %s bestanden toevoegen.'
    }
});

Parsley.on('field:error', function () {
    var $element = this.$element;

    if ($element.is(':radio, :checkbox')) {
        $('[name="' + $element.attr('name') + '"]').attr('aria-invalid', 'true');
    } else {
        $element.attr('aria-invalid', 'true');
    }

    var errorsId = 'parsley-errors-' + $element.attr('id');
    $element.attr('aria-describedby', errorsId);
    $element.closest('.form-group, [class*="col-"]').find('.parsley-errors-list').attr('id', errorsId);
});

Parsley.on('field:success', function () {
    var $element = this.$element;

    if ($element.is(':radio, :checkbox')) {
        $('[name="' + $element.attr('name') + '"]').removeAttr('aria-invalid').removeAttr('aria-describedby');
    } else {
        $element.removeAttr('aria-invalid');
        $element.removeAttr('aria-describedby');
    }
});

$('form:not([novalidate])').parsley();
